import { render } from "./Delete.vue?vue&type=template&id=b497e14a&scoped=true"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"

import "./Delete.vue?vue&type=style&index=0&id=b497e14a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b497e14a"]])

export default __exports__